export enum IntegrationsTab {
  APPS = 'apps',
  IDENTITY_PROVIDERS = 'identity-providers',
  SAE_INTEGRATIONS = 'sae-integrations',
}
